import React from 'react';
import MultiSelectFilter from 'components/ReactTable/Filters/MultiSelectFilter';
import SelectFilter from 'components/ReactTable/Filters/SelectFilter';
import CustomerLinkCell from 'components/ReactTable/CellRenderers/CustomerLinkCell';
import AccountLinkCell from 'components/ReactTable/CellRenderers/AccountLinkCell';

// note: for the sorting to work, the 'accessor' properties below must have the same name as the backend property to be sorted by
const formColumnDefs = permissions => [
  {
    Header: 'Form Type',
    accessor: 'formTypeDescription',
    Filter: MultiSelectFilter,
    className: 'col-7p5'
  },
  {
    Header: 'Customer',
    accessor: 'customer',
    Cell: cellInfo => (
      <CustomerLinkCell dataKey="customerDbId" data={ cellInfo.row.original } permissions={ permissions } />
    ),
    className: 'col-12p5'
  },
  {
    Header: 'Account',
    accessor: 'account',
    Cell: cellInfo => (
      <AccountLinkCell dataKey="accountId" data={ cellInfo.row.original } permissions={ permissions } />
    ),
    className: 'col-12p5'
  },
  {
    Header: 'Source',
    accessor: 'formSourceDescription',
    Filter: MultiSelectFilter,
    className: 'col-6p5'
  },
  {
    Header: 'Workflow',
    accessor: 'workflowStatus',
    Filter: MultiSelectFilter,
    className: 'col-10p'
  },
  {
    Header: 'Validity',
    accessor: 'isValid',
    Filter: SelectFilter,
    filterType: 'bool',
    className: 'col-6p5'
  },
  {
    Header: 'Date of Validation',
    accessor: 'validationDate',
    disableFilters: true,
    className: 'col-7p5'
  },
  {
    Header: 'Uploaded By',
    accessor: 'uploadedBy',
    disableSortBy: true,
    className: 'col-10p'
  },
  {
    Header: 'Assigned To',
    accessor: 'workflowUsername',
    disableSortBy: true,
    className: 'col-10p'
  },
  {
    Header: 'Item Id',
    accessor: 'itemId',
    isVisible: false
  }
];

export default formColumnDefs;
